module.exports = __webpack_public_path__ + "static/media/unit 3-16.1bd9883b.jpg";